import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice";

const selectDomain = (state) => state.reportExport || initialState;

export const selectReportExportData = createSelector(
  [selectDomain], 
  (state) => state.data
);

export const selectReportExportLoading = createSelector(
  [selectDomain], 
  (state) => state.loading
);

export const selectReportExportError = createSelector(
  [selectDomain], 
  (state) => state.error
);
export const selectReportExportMessage = createSelector(
  [selectDomain],
  (state) => state.message
);
